import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const HowItWorks = () => {
  const [sectionRef, sectionVisible] = useScrollAnimation({ threshold: 0.1 });
  const [stepRef1, stepVisible1] = useScrollAnimation({ threshold: 0.2 });
  const [stepRef2, stepVisible2] = useScrollAnimation({ threshold: 0.2 });
  const [stepRef3, stepVisible3] = useScrollAnimation({ threshold: 0.2 });
  const [stepRef4, stepVisible4] = useScrollAnimation({ threshold: 0.2 });

  const steps = [
    {
      week: 'Week 1-2',
      title: 'Feasibility & Setup',
      description: 'We analyze your portfolio data, loss ratios, and premium flow to determine the optimal captive structure (single parent, group, cell, reant-a-captives).',
      number: '01',
      ref: stepRef1,
      visible: stepVisible1
    },
    {
      week: 'Week 3-6',
      title: 'Licensing & Formation',
      description: 'We manage all regulatory filings, capital structuring, and compliance implementation on your behalf.',
      number: '02',
      ref: stepRef2,
      visible: stepVisible2
    },
    {
      week: 'Week 7-8',
      title: 'Program Management',
      description: 'We integrate your captive with your resident insurance workflow - collecting premiums, managing policies, and administering claims seamlessly.',
      number: '03',
      ref: stepRef3,
      visible: stepVisible3
    },
    {
      week: 'Ongoing',
      title: 'Ongoing Administration',
      description: 'Ongoing administration includes monthly financial compilation and review, regulatory filings, and performance tracking, all managed through our captive management platform.',
      number: '04',
      ref: stepRef4,
      visible: stepVisible4
    }
  ];

  return (
    <section className="how-it-works-wrapper" id="how-it-works" ref={sectionRef}>
      {/* Vertical Dividers */}
      <div className="how-it-works-divider how-it-works-divider-1"></div>
      <div className="how-it-works-divider how-it-works-divider-2"></div>
      <div className="how-it-works-divider how-it-works-divider-3"></div>
      <div className="how-it-works-divider how-it-works-divider-4"></div>
      <div className="how-it-works-divider how-it-works-divider-5"></div>

      {/* Header Section */}
      <div className={`how-it-works-header ${sectionVisible ? 'animate-fade-up' : 'opacity-0'}`}>
        <h2 className="how-it-works-title">How it Works?</h2>
        <p className="how-it-works-description">
          Go from feasibility to full operation faster than you thought possible — our streamlined process makes it simple.
        </p>
      </div>

      {/* Steps Grid */}
      <div className="how-it-works-steps-grid">
        {steps.map((step, index) => (
          <div 
            ref={step.ref}
            key={index}
            className={`how-it-works-step-card ${step.visible ? 'animate-slide-up' : 'opacity-0'}`}
            style={{ transitionDelay: `${index * 0.1}s` }}
          >
            <div className="how-it-works-step-label">
              <span className="how-it-works-step-text">{step.week}</span>
            </div>
            <h3 className="how-it-works-step-title">{step.title}</h3>
            <p className="how-it-works-step-description">{step.description}</p>
            <div className="how-it-works-step-number">{step.number}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
